/**
 * My Account page shell (Figma node 71:4944) — layout/nav are pure CSS.
 * The one bit of behavior: "Wysyłka na inny adres" toggles the shipping
 * address section on "Twoje dane" (inc/my-account.php's render_endpoint()).
 */

import './index.scss';

const shippingToggle = document.querySelector('[data-shipping-address-toggle]');
const shippingSection = document.querySelector('[data-shipping-address-section]');

if (shippingToggle && shippingSection) {
	shippingToggle.addEventListener('change', () => {
		shippingSection.hidden = !shippingToggle.checked;

		// WooCommerce's country-select.js only enhances `:visible` selects
		// with select2, so a section hidden on page load keeps a native
		// "Kraj/region" <select>. Its own re-init listener runs on this event
		// (jQuery .on() binds via addEventListener, so a native event reaches it).
		if (shippingToggle.checked) {
			document.body.dispatchEvent(new Event('country_to_state_changed'));
		}
	});
}

// Strips anything that isn't a digit as the shopper types — the field's
// pattern/maxlength (inc/my-account.php's add_company_and_nip_fields())
// only reject on submit, so this catches it live instead.
const nipInput = document.querySelector('#billing_nip');

nipInput?.addEventListener('input', () => {
	nipInput.value = nipInput.value.replace(/\D/g, '').slice(0, 10);
});
